<template>
  <div class="page border-box">

    <div class="account-notice border-box" v-if="tips">
      <img src="../../assets/icon_16.png" alt="">
      <div class="account-notice-info curr">
        <p>{{tips}}</p>
      </div>
    </div>
    <div class="pay-box border-box box">
      <img class="flex video-img" :src="bag.logo" alt="">
      <div class="flex">
        <p class="video-tit hide">{{bag.name}}</p>
        <p class="video-num">包含{{bag.vnum}}个解说点</p>
        <p class="video-price">￥{{bag.price}}</p>
      </div>
    </div>

    <div class="pay-box vip-li" :class="checkAllTrue?'curr':''" @click="checkAllTrueClick">
      <p class="vip-top border-box">购买当前整张专辑 <font style="font-size: .32rem;font-weight: bold;color: #e41919;"> ￥{{bag.price}}</font></p>
    </div>

    <div class="group-ul group-ul1">
      <p class="group-ul1-txt">购买单个解说点
        <span v-if="spotids.length>0">（已选{{spotids.length}}个）</span>
      </p>
      <div class="box border-box group-li" :class="[item.selsect==1?'curr':'',item.buy>0?'buy':'']" v-for="(item,index) in siteBrotherList" :key="index" @click="goViewDetail(index)">
        <img v-lazy="item.logo" alt="" :data-id="item.id" :data-ind="index">
        <p class="flex hide">
          {{index+1}}.{{item.title}} <font style="font-size: .24rem;color:#ff5455;"> {{item.curr==1?'已购':('￥'+item.price)}}</font>
        </p>
      </div>
    </div>




    <div class="pay-btn" @click="payWxOrder">
      <div class="fl left" :class="buyAll==1?'curr':''">
        <div class="fl txt">合计：</div>
        <div class="fl price">
          <p class="p1"><span>￥</span>{{totalPrice}}</p>
        </div>
      </div>
      <div class="right-btn">立即支付</div>
      <p class="buyTip" v-if="buyAll==1">支付 {{totalPrice}}元 即可解锁整张专辑</p>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
    <!--<router-link class="pay-tip" to="/agreement">点击立即购买，即表示您已经同意<span>《金牌解说语音协议》</span></router-link>-->

  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getOrderProd, creatWxOrder, creatYOrder, pushOrder,creatWxOrderMeb, creatYOrderMeb,mulCreateOrder,} from '@/utils/wechat'
  import {getOTAcode,activeOTAcode,checkShopIsOTA,needMember,bundlePrice,spotBuyDetail,spotBuyPrice} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import AlertOTA from '../../components/AlertOTA'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        P400: 0, //系统维护中
        userInfo: {}, //用户信息
        shopid: '', //景区id
        spotid: '', //景点id
        pid: '', //专辑id
        isbuy: 0, //未购买
        bagtype: '', //视频产品
        isshow: '', //是否显示一网通

        res: {}, //返回结果
        bag: {}, //产品信息
        coupon: {}, //优惠卡包
        payWay: 0, //0:默认微信支付，1:一网通支付，2:支付宝支付，3:激活码激活，4:购买会员
        valueData: '',

        siteBrotherList: [], //所包含的语音包
        siteBrotherShow: true, //是否展开语音包

        appKey: '',
        OTAcode: '', //激活码
        OTAShow: 0, //是否显示激活码操作

        memberWay: 0, //是否开通会员
        memberList: [], //可购买的会员列表
        memberInd: 0, //选择购买哪个会员

        ids: [], //最终接选择的id结果数组
        spotids: [], //最终接选择的spotid结果数组
        checkAllTrue: false, //是否选择了全部
        buyAll: 0, //购买金额达到一定数量，即可解锁整张专辑

        isBuyOne: 2, //2：默认购买当前语音  1：捆绑专辑购买
        totalPrice: 0, //多张购买的价格
        model: 1, //1：捆绑包专辑购买
        tips: '', //提现消息
      }
    },
    computed: {

    },
    created() {
      this.global.set_glabalClear()

      this.shopid = this.$route.query.shopid || '';
      this.spotid = this.$route.query.spotid || '';
      this.pid = this.$route.query.pid;
      this.isbuy = this.$route.query.isbuy || '';
      this.bagtype = this.$route.query.bagtype || '';
      this.userInfo = getStore("userInfo");

      this.appKey = this.$route.query.appKey || "";
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      if(this.isbuy == 1){
        setStore("couponid", {"couponid": ""});
        this.$router.replace({
          path: `/video-play-py?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay'+'&appKey='+this.appKey+'&paySuccess=1'}`
        });
      }else {
        this.spotBuyDetailFun();
      }

    },
    methods: {
      //获取支付详情
      async spotBuyDetailFun(){
        let res = await spotBuyDetail({
          openid: this.userInfo.openid,
          spotId: this.spotid,
          bagId: this.pid
        });
        if(res.errcode == "00000"){
          this.tips = res.data.tips || '';
          if(res.data.bag.curr == 1){ //1：已经购买整张专辑
            setStore("couponid", {"couponid": ""});
            this.$router.replace({
              path: `/video-play-py?${'id='+this.pid+'&spotid='+this.spotid+'&shopid='+this.shopid+'&form=pay'+'&appKey='+this.appKey+'&paySuccess=1'}`
            });
          }else {
            this.bag = res.data.bag;
            if(res.data.list.length>0){

              var list = res.data.list;
              for(var i=0; i<list.length; i++){
                if(this.spotid == list[i].spotId){
                  list[i]['selsect'] = 1;
                }else {
                  list[i]['selsect'] = 0;
                }
              }
              console.log(list);
              this.siteBrotherList = list;
              if(this.spotid){
                var ind = this.getIndex(list,this.spotid);
                this.ids = [list[ind].id];
                this.spotids = [this.spotid];
                this.spotBuyPriceFun();
              }else {
                this.checkAllTrue = true; //购买整张专辑
                this.totalPrice = res.data.bag.reprice;
              }
            }

          }
        }else{
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //选择购买整张专辑
      checkAllTrueClick: function (){
        this.checkAllTrue = true;
        this.idsArr = [];
        this.spotids = [];

        var list = this.siteBrotherList;
        for(var i=0; i<list.length; i++){
          list[i]['selsect'] = 0;
        }
        this.siteBrotherList = list;
        this.spotBuyPriceFun();
      },

      //勾选需要购买的专辑
      goViewDetail: function (ind){
        var item = this.siteBrotherList[ind];
        if(item.curr==1){
          this.$toast('此解说点已购买')
        }else {
          this.checkAllTrue = false;

          this.siteBrotherList[ind].selsect = (item.selsect==1?0:1);
          this.$set(this.siteBrotherList, ind, this.siteBrotherList[ind]);

          var arr = [],arr1 = [], list = this.siteBrotherList;
          for(var i=0; i<list.length; i++){
            if(list[i].selsect==1){
              arr.push(list[i].spotId);
              arr1.push(list[i].id)
            }
          }
          this.spotids = arr;
          this.ids = arr1;

          this.spotBuyPriceFun();
        }

      },

      //重新计算价格
      async spotBuyPriceFun(){
        let res = await spotBuyPrice({
          openid: this.userInfo.openid,
          ids: this.spotids.join(','),
          bagId: this.pid
        });
        if(res.errcode === "00000"){
          this.totalPrice = res.data.price;
          this.buyAll = res.data.curr;
        }
      },

      //立即购买(微信支付)
      payWxOrder(){
        MtaH5.clickStat('xiangqingyeshit',{'viewdetailpay':'true'});//景区景点点击试听》弹窗购买》1支付
        MtaH5.clickStat('zhuanjixiangqin',{'pay':'true'});//专辑详情页点击推荐景区》购买》1支付
        MtaH5.clickStat('viewspotbuy',{'2viewspotpay':'true'});//景区景点直接点击购买》1支付
        MtaH5.clickStat('jingqujingdiana',{'3pay':'true'});//景区景点点击导游头像》个人主页购买》1支付
        MtaH5.clickStat('jingqujingdiana-1',{'3pay':'true'});//景区景点试听》直接购买》1支付
        MtaH5.clickStat('jingqujingdiana-2',{'3pay':'true'});//景区景点进入专辑详情》点击购买》1支付
        MtaH5.clickStat('jingqujingdiana-3',{'4pay':'true'});//景区景点进入专辑详情》试听》购买》1支付

        var self = this,bundleid = '',ids='';
        if(this.checkAllTrue==true || this.buyAll==1){ //购买整张专辑
          bundleid = 'createorder'
        }else{ //购买多个景点
          ids = this.ids.join(',');
          bundleid = 'order';
        }
        mulCreateOrder(self,ids,bundleid,function(data){
          setStore("couponid", {"couponid": ""});
          if(data){
            self.payWxSucc();
          }
        });


      },

      payWxSucc(){
        let self = this;

        pushOrder('dist/index.html#/video-play-py?id='+self.pid+'&spotid='+self.spotid+'&shopid='+self.shopid+'&paySuccess=1'+ '&appKey='+ self.appKey);

      },



      //拿到数组中指定id的下标
      getIndex(arr,id){
        let result;
        if(arr.find(function(x) {return x.spotId == id;}) != undefined) {
          arr.find(function(x,i) {
            if(x.spotId == id){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //获取专辑合集的所有专辑id
      getIdsArr: function (){
        var idsArr = [];
        for(var i=0; i<this.siteBrotherList.length; i++){
          if(this.pid == this.siteBrotherList[i].bid){
            idsArr.push(this.siteBrotherList[i].bid);
            break;
          }
        }
        for(var i=0; i<this.siteBrotherList.length; i++){
          if(this.pid != this.siteBrotherList[i].bid){
            idsArr.push(this.siteBrotherList[i].bid);
          }
        }
        return idsArr;
      },

      //点击购买多张专辑
      isBuyOneClick: function (){
        if(this.isshow==1){
          this.payWay=1;
        }else {
          this.payWay=0;
        }

        this.idsArr = this.getIdsArr();
        this.memberWay=0;
        this.isBuyOne=1;
        this.siteBrotherShow=true;
        this.spotBuyPriceFun()
      },

    },
    components: {
      AlertOTA,P400
    },
  }

</script>

<style scoped>
  .page{min-height:100vh;padding:.24rem .3rem 1.8rem;background: #f3f3f3;}
  .pay-top{padding: 0 .24rem .2rem;background: #fff;border-radius: .14rem;}
  .pay-top-li{width: 100%;height: .9rem;line-height:.9rem;border-bottom: 1px dashed #a5a5a5;}
  .pay-top-li span{font: .28rem/.9rem "Microsoft YaHei";}
  .pay-top-li .fl{color: #3f3f3f;}
  .pay-top-li .fr{color: #ff5455;}
  .pay-top-li .fr img{float: right;width:auto;height: .15rem;margin-top: .445rem;margin-left: .2rem;}
  .pay-top-li input{float: right;font: bold .28rem/.9rem "Microsoft YaHei"; color:#222;max-width:63%; text-align: right; }
  .pay-top-tip{padding-top: .14rem;color: #3f3f3f;}
  .pay-top-tip p{font-size: .24rem;}
  .pay-top-tip div{margin-top:.1rem;font-size: .22rem;line-height: .36rem;}

  .pay-bottom{margin-top:.24rem;padding: 0 .3rem;background: #fff;border-radius: .08rem;}
  /*.pay-btn{ display: block; padding: 0; width: 85%;height: .98rem;margin:.69rem auto 0;font: .32rem/.98rem "Microsoft YaHei";color: #fff;text-align: center;background: linear-gradient(to right, #fccd5b, #faaf39);border-radius: .6rem;box-shadow: 0 20px 40px #f5efc9;}*/
  /*.pay-btn span{margin-left: .11rem;}*/
  .pay-tip{display: block;width: 85%;margin: .26rem auto 0;line-height:.4rem;font-size: .2rem;color: #333;text-align: center;}
  .pay-tip span{color:#fecf02;}
  .pay-bottom-li{position:relative;width: 100%;height: 1rem; line-height: 1rem; padding-left: .74rem; -webkit-box-align: center; -ms-flex-align: center; align-items: center;}
  .pay-bottom-li .fl{font-size: .28rem;color: #2e2a27;}
  .pay-bottom-li .fl img{position:absolute;left:0;top:50%;width: .45rem;height:auto;transform: translateY(-50%);}
  .pay-bottom-li .fr img{float: right;width: .4rem;height: .4rem;margin-top: .3rem;}
  .pay-bottom-yh{ padding: .02rem .15rem; color:#fff; font-size: .2rem; background-color: #ff5455; border-radius: .3rem; }

  .pay-vip-tip{ display: block; font-size: .24rem; color: #666; line-height: .3rem; margin-top: -.2rem; }
  .vip-list{ padding: .14rem .25rem .3rem; -webkit-box-align: center; -ms-flex-align: center; align-items: center; }
  .vip-list > .flex{ width: 33.33%; }
  .vip-box{ margin: 0 .14rem; height: 1.2rem; border: .02rem solid #dbdce0; border-radius: .08rem; text-align: center; font-weight: bold; }
  .vip-box .top{ height: .4rem; line-height: .4rem; font-size: .24rem; color: #666; background-color: #e8e8e8; }
  .vip-box .pri{ height: .8rem; line-height: .8rem; font-size: .3rem; color: #ff5511; }
  .vip-box .pri i{ font-size: .24rem; font-style: normal; }
  .vip-box .pri b{ font-size: .22rem; color: #999; text-decoration: line-through; }
  .vip-box.curr{ border-color: #fac551; }
  .vip-box.curr .top{ color: #825d0e; background-color: #fac551; }

  .pay-box{padding: .25rem .24rem .27rem;margin-top:.01rem;background: #fff;border-radius: .08rem;}
  .pay-box:first-child{margin-top: 0;}
  .video-img{width: 1.7rem;height: 1.4rem;margin-right: .24rem;border-radius: .08rem;object-fit: cover;}
  .video-tit{ margin-top: .05rem; font-weight: bold;color: #333;font-size: .33rem;}
  .video-num{ margin-top: .05rem;font-weight: bold;color: #666;font-size: .28rem;}
  .video-price{margin-top:.05rem;font-weight: bold;font-size: .32rem;color: #e41919; line-height: .4rem;}

  .vip-li{position: relative;border: 1px solid #fff;}
  .vip-li.curr{border: 1px solid #fcc753;background: #fffcf7;}
  .vip-li .price-rt{position: absolute;top:.3rem;right:.3rem;font-size: .32rem;font-weight: bold;color: #e41919;}
  .vip-li .price-rt b{ font-weight: normal; font-size: .28rem; color: #999; text-decoration: line-through; }
  .vip-li .vip-top{font-size: .3rem;color: #333;font-weight: bold;}
  .vip-li .vip-top img{display: inline-block;width: auto;height: .4rem;vertical-align: sub;}
  .vip-li .vip-top span{font-size: .28rem;color: #666;font-weight: bold;}
  .vip-li .vip-bot{margin-top:.26rem;font-size: .28rem;color: #666;font-weight: bold;}
  .vip-li .vip-bot.cont .fr{ color: #e41919; }
  .vip-li .vip-bot.cont .fr img{ width: .13rem; }
  .vip-li .vip-bot.code{width: 100%;height: .72rem;margin-top: .15rem;border-radius: .08rem;overflow: hidden;}
  .vip-li .vip-bot.code input{display: inline-block;width: 100%;height:100%;padding: 0 .16rem;border-radius: .08rem;background: #f6f6f6;font-size: .28rem;color: #666;}
  .pay-bottom1{height: 1.26rem;margin-top:.24rem;padding: 0 .3rem;background: #fff;border-radius: .08rem;}
  .pay-bottom1 .pay-bottom-li{float:left;position:relative;width: 50%;height: 1.26rem;line-height: 1.26rem;padding-left: .74rem;}
  .pay-bottom1 .pay-bottom-li .fl{font-size: .28rem;color: #2e2a27; }
  .pay-bottom1 .pay-bottom-li .fl img{position:absolute;left:0;top:50%;width: .45rem;height:auto;transform: translateY(-50%);}
  .pay-bottom1 .pay-bottom-li .pay-icon img{float: left;width: .4rem;height: .4rem;margin-top: .43rem;margin-left: .16rem;}
  .pay-bottom1 .pay-bottom-li.noOtherPay{width: 100%;}
  .pay-bottom1 .pay-bottom-li.noOtherPay .pay-icon img{float: right;}
  .pay-bottom1 .pay-bottom-li .fl .pay-bottom-yh{ position: absolute; height: .24rem;left: .74rem; top: .8rem; line-height: .24rem; border-radius: 0 .09rem .09rem .09rem; }
  .pay-btn{position: fixed;left: 0;right: 0;bottom:0;height: 1.36rem;background: #fff;}
  .pay-btn .left{width: calc(57.34vw - 1.02rem);margin-top: .44rem;margin-left: .4rem;}
  .pay-btn .left .txt{font-size: .28rem;color: #333;font-weight: bold;}
  .pay-btn .left .price{padding-left:.2rem;color: #e41919;font-weight: bold;}
  .pay-btn .price .p1{font-size: .36rem;}
  .pay-btn .price .p1 span{font-size: .28rem;}
  .pay-btn .price .p2{font-size: .24rem;}
  .pay-btn .right-btn{position:absolute;z-index:1;top:.24rem;right:.3rem;width: 42.66%;height: .88rem;line-height: .88rem;margin-left:.32rem;background: #fcc753;border-radius: .5rem;font-size: .34rem;font-weight: bold;color: #333;text-align: center;  }
  .buyTip{position: absolute;  left: .4rem;  top: .1rem;  font-size: .26rem;  font-weight: bold; color: #e41919; }
  .pay-btn .left.curr{margin-top: .55rem;}

  /*建川博物馆类型*/
  .video-price .fr{ position: relative; font-weight: normal;font-size: .24rem; color: #666; }
  .video-price .fr:after{ position: absolute; left: 50%; top: .4rem; z-index: 1; margin-left: -.12rem; width:.24rem; height:.13rem; background: url(../../assets/icon-down.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .video-price .fr.curr:after{ transform: rotate(180deg) ; }

  .group-ul{ background-color: #fff; padding: 0 .24rem; }
  .group-li{ position: relative; padding: .1rem .4rem .1rem 0; background-color: #fff; border-top: .01rem solid #e0e0e0; }
  .group-li:after{ position: absolute; right: .15rem; top: 50%; margin-top: -.09rem; width:.11rem; height:.18rem;  background: url(../../assets/back.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-li img{ width: .6rem; height: .4rem; object-fit: cover; }
  .group-li p{  margin-left: .2rem;font-size: .26rem;line-height: .4rem; color: #333;  }

  .group-ul1{margin-top: .1rem;}
  .group-ul1-txt{padding:.26rem 0;font-size: .3rem;color: #333;font-weight: bold;}
  .group-ul1-txt span{font-size: .26rem;font-weight: normal;color: #666;}
  .group-ul1-txt font{color: #e41919;}
  .group-ul1 .group-li:after{ margin-top: -.15rem; width:.3rem; height:.3rem;  background: url(../../assets/pay-icon.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li.curr:after{background: url(../../assets/pay-icon-curr1.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li.buy:after{background: url(../../assets/pay-icon-curr3.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li.buy p{color: #999;}
  .vip-li:after{ position: absolute; right: .38rem; top: 50%; margin-top: -.15rem; width:.3rem; height:.3rem; background: url(../../assets/pay-icon.png) no-repeat center; background-size: 100% 100%; content: '';}
  .vip-li.curr:after{ background: url(../../assets/pay-icon-curr1.png) no-repeat center; background-size: 100% 100%; content: '';}

  /*消息提醒*/
  .account-notice{ position: relative; width: 100%; padding-left: .9rem; height: .72rem; overflow: hidden; background-color: #faf9f7; }
  .account-notice img{ position: absolute; left: .275rem; top: .15rem; z-index: 1; width: .35rem;}
  .account-notice-info { position: relative; display: block; width: 100%; height: .72rem; overflow: hidden;}
  .account-notice-info p{ position: absolute; left: 100vw; z-index: 2; width: auto; height: .72rem; line-height:.72rem; font-size:.28rem; color: #db5004; opacity: 1;}
  .account-notice-info.curr p{ animation: scrollInline 12s linear infinite; }
  @keyframes scrollInline {0%{left: 100vw;}100%{left: -150%;}}
</style>



// WEBPACK FOOTER //
// src/page/pay/pay-py.vue